export default __webpack_public_path__ + "locales/si/Profile.json?hash=9365ae6c1a828452e9200bec18fa7445";